import { Router } from '@angular/router';
import { Component, Input, OnInit, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { NspUpgradeService } from './nsp-upgrade.service';
import { Modal, Dropdown, TABS_DIRECTIVES } from '@clr/angular';
import { VcaAlertsService } from './../../../../common/vca-alerts';
import { UpgradeDate } from './../upgradedate/upgrade-date.component';
//import * as Clipboard from 'clipboard';
//import { AuthService } from './../auth/auth.service';
//import UpgradeDate from './../upgradedate/upgrade-date.component';
import { ClientUtilities } from '../utils/client-utils';
import { FeatureEnablementService } from './feature-enablement.service';
//import { error } from 'util';
import { limitdecimals } from '../../../../publisher/utils/utils';
import { DEFAULT_RELEASE_NOTE_TXT, PARSING_ERROR_MESSAGE } from '../publisher_constants';
import { HttpResponse } from '@angular/common/http';
var clipboardJs = require("clipboard-js")
//let fullScreenOverlayHost = require('../utils/fullScreenOverlayHost');
const _ = require('lodash');

@Component({
    selector: 'nspupgrade',
    template: require('./nsp-upgrade.html'),
    styleUrls: ['./nsp-upgrade.scss']
})

export class NspUpgradeComponent implements OnInit {
    @ViewChild('myComponentElement') myComponentElement: ElementRef;

    private nspBuild: string = '';
    private nspData: any[];
    private getHandler = null;
    private getRemoteHandler = null;
    private downloadBundleHandler;
    private startNspUpgradeHandler;
    private getAvailBundlesHandler;
    private currentRowUpgrade = 0;
    private availBundles: any[] = [];
    private upgradeConfirmDlg: boolean = false;
    private showDropDown: boolean = false;
    private showRunningBtn: boolean = false;
    private showSuccessBtn: boolean = false;
    private showErrorBtn: boolean = false;
    private disableSelectBuildBtn: boolean = false;
    private disableOkBtn: boolean = true;
    private theMessage: string = '';
    private isShowMsg: boolean = false;
    private userName: string = '';
    private userPw: string = '';
    private isPairings: boolean = false;
    private isLoading: boolean = false;
    private selected: any;
    private scheduleUpgrade: boolean = false;
    private dailyHrs: any[] = [];
    private dailyMinutes: any[] = [];
    private inputDate: string = '';
    private buildList: boolean = false;
    private currentHour: any;
    private currentMinutes: any;
    private timing: string = '';
    private AM: boolean;
    private isVsphereClient: boolean = false;
    private scheduledDate: any;
    public bundleExists: boolean;
    private isUpgradingAlertShown: boolean = false;
    private remoteNspUpgradeData: any[];
    private upgradeScheduleTime: any;
    private isDownloading: boolean = false;
    private isUpgrading: boolean = false;
    private scheduleData = {};
    private isDownloadStarted: boolean;
    private downloadOvaBundleHandler;
    private ovaBundleDownloadLink: string = '';
    private cssTopSubmenu: any;
    private isVersionOperationsDropdownVisible: boolean = false;
    private readMeDialogue: boolean = false;
    private isBuildDropdownVisible: boolean = false;
    private yPos: any;
    private buildDropDownPos: any;
    private buildDropDown = {};
    private buildDropDownList: any[] = [];
    private operatingRowStatus: any = 0;
    private releaseNote: any;
    private releaseNoteFeatures: any;
    private releaseNoteIssues: any[] = [];
    private releaseNoteSecurity: any[] = [];
    private defaultLocalReleaseNotes = {
        features: '',
        issues: '',
        security: ''
    };
    private defaultLocalReleaseNoteFeatures: any[] = [];
    private defaultLocalReleaseNoteIssues: any[] = [];
    private defaultLocalReleaseNoteSecurity: any[] = [];
    private defaultLocalReleaseNoteDialogue: boolean;
    private defaultLocalReleaseNote: boolean;
    private ovaBundleLink: boolean = false;
    private isUpgradeConfirmationDialogVisible = false;
    private isLinkAvailable: boolean ;
    private upgradeRow = {};
    private selectedBuild = {};
    private colWidth: any = 4;
    private showLinkSpinner: boolean = true;
    private enableInfoLink: boolean = false;
    private buildDropdownPos: string = '';
    private ovaLinkInfo: string = '';

    private innerContentFeatures: string = '';
    private innerContentIssues: string = '';
    private innerContentSecurity: string = '';
    private featureMap: Map<string, object> = new Map<string, object>();
    private showHcxEDownloadLink: boolean = false;
    private isUpgradeable: boolean;
    public isOvaBundleSubscribed: boolean;
    public currentClassName: string = '';
    public updateStatus :any;
    private isMenuClicked: boolean;
    private isMenuAvailable: any;
    private isNspDataAvailable: any;
    public upgradeTasksLnk:boolean;
    public upgradeTaskData;
    public jobId;
    public upgradeMsg:string;
    private upgradeStatusBanner:boolean;
    public upgradeCheckHandler;
    public applianceScheduled = {};
    public upgradableBuildText : string = '';
    public selectedItem:{};
    public indexVal:number;
    public isNotifloading = false;
    public isEoGS = false;
    private releaseNoteErr : boolean;
    private readonly parsingErrMsg = PARSING_ERROR_MESSAGE;
    public upgradeLogsNotFound = false;
    public upgradeUpgradeLogProgress = false;
    isHCXWithoutCnC: boolean;

    constructor(
        public nspUpgradeService: NspUpgradeService,
        public featureEnablementService: FeatureEnablementService,
        private router: Router,
        private cdRef: ChangeDetectorRef,
        private alert: VcaAlertsService,
        /*private authSvc:AuthService*/) {
        this.currentClassName = 'NspUpgradeComponent';
        this.checkEvent();
        var hcxLicenseData = JSON.parse(sessionStorage.getItem('hcx-license-data'));
        this.isHCXWithoutCnC =  hcxLicenseData.data 
                                && hcxLicenseData.data.activationType 
                                && ['STANDALONE_CONNECTED', 'STANDALONE_DISCONNECTED'].indexOf(hcxLicenseData.data.activationType.toUpperCase()) > -1
    }

    ngOnInit() {
        const me = this;
        this.isNotifloading = true;
        this.nspUpgradeService.queryHcmInstances(
            () => setTimeout(() => me.initApplication(), 10), // success callback
            null);  //error callback
        
        this.nspUpgradeService.latestVersionForDownload.subscribe((text)=>{
            this.isNotifloading = false;
            this.upgradableBuildText = text;
        },(err)=>{
            this.isNotifloading = false;
        })
    }

    initApplication() {
        const path = (window.location.pathname.match(/(.*)(\/publisher-ui)(\/.*|$)/) || [])[1];
        this.isVsphereClient = !!path && ClientUtilities.runningInPluginUI();

        this.getEnabledFeatures();

        let currentDate = new Date();

        this.currentMinutes = currentDate.getMinutes();
        if (this.currentHour < 12) {
            this.AM = true;
            this.timing = 'AM';
        } else {
            this.AM = false;
            this.timing = 'PM';
        }
        this.currentHour = currentDate.getHours() % 12 || 12;
        this.inputDate = currentDate.toISOString().split('T')[0];
        this.isLoading = false;
        this.dailyHrs.length = 12;
        this.dailyMinutes.length = 60;
        this.getAllNspData();
        this.getRemoteNspData();
        let subsData: any[];
        this.downloadOvaBundle();
        this.nspUpgradeService.notifyUpgradeMessage()
            .map((obj, ind) => {
                for (var x = 0; x < obj.length; x++) {
                    obj[x]['availableBundles'].length > 0 ? this.bundleExists = true : '';  //check if bundle exists to display alert TBD: fix flashing, move it to service
                }
            })
            .filter(obj => obj == null)
            .subscribe();
        this.nspUpgradeService.getDefaultLocalReleaseNotes().then(  //Get current build release notes from service
            response => {
                if (response.data.hasOwnProperty('items')) {
                    let noOfItems = response.data.items.length;
                    if (noOfItems == 1) {
                        this.defaultLocalReleaseNoteDialogue = false;
                        this.defaultLocalReleaseNote = true;
                        this.defaultLocalReleaseNotes = JSON.parse(response.data.items[0].externalReleaseNote);
                    }
                    //TBD handle multiple release notes
                }
            }
        );
        this.setMenu();
        if(!this.isHCXWithoutCnC){
            this.checkApplianceUpgradeSchedule();
        }
    }

    private getResumeJobsData(isRemote: boolean): void {
        let me = this,
            data = isRemote ? me.remoteNspUpgradeData : me.nspData;
        data.forEach(function (item, ind) {
            // XXX it would be better to send whole item down and let "consumer" to take care of the rest....
            let siteInfo = {
                endpointId: item.systemId
            }
            item.statusHandler = me.nspUpgradeService.queryJobWithFilters(siteInfo, item._source.uuid).subscribe(resp => {
                item.resumeJobsData = resp.data;
                me.getLastUpgradeJob(item);
                //me.getDownloadBundleStatusTesting();
            });
        });
    }

    private handlePollerResponse(data: any, itemBeingDownloaded): void {
        let thisNg = this,
            respData = data;
        switch (respData.data.status) {
            case 'DOWNLOADING_BUNDLE':
                itemBeingDownloaded.showRunningBtn = true;
                itemBeingDownloaded.operationStatus = respData.data.status.replace(/_/g, " ");
                itemBeingDownloaded.downloadProgress = respData.data.downloadProgress;  //percent Indicator
                itemBeingDownloaded.isDownloading = true;
                itemBeingDownloaded.isUpgrading = true;
                thisNg.upgradeTasksLnk=true;
                break;
            case 'DOWNLOADING_ADDON':
                itemBeingDownloaded.showRunningBtn = true;
                itemBeingDownloaded.operationStatus = respData.data.status.replace(/_/g, " ");
                itemBeingDownloaded.downloadProgress = respData.data.downloadProgress;  //percent Indicator
                itemBeingDownloaded.isDownloading = true;
                itemBeingDownloaded.isUpgrading = true;
                thisNg.upgradeTasksLnk=true;
                break;
            case 'DOWNLOADED_BUNDLE':
                itemBeingDownloaded.operationStatus = respData.data.status.replace(/_/g, " ");
                itemBeingDownloaded.downloadProgress = respData.data.downloadProgress;
                itemBeingDownloaded.isUpgrading = false;
                if ((itemBeingDownloaded.isPerformingOperation == true) && (itemBeingDownloaded.downloadProgress == 100)) {
                    itemBeingDownloaded.downloadProgress = respData.data.downloadProgress;
                    itemBeingDownloaded.pollDownloadHandler.unsubscribe();
                    thisNg.upgradeTasksLnk=false;
                }
                break;
            case 'SCHEDULED':
                itemBeingDownloaded.operationStatus = respData.data.status.replace(/_/g, " ");
                itemBeingDownloaded.downloadProgress = respData.data.downloadProgress;
                itemBeingDownloaded.isUpgrading = false;
                if ((itemBeingDownloaded.isPerformingOperation == true) && itemBeingDownloaded.downloadProgress == 100) {
                    itemBeingDownloaded.pollDownloadHandler.unsubscribe();
                }
                break;
            case 'EXTRACTING_BUNDLE':
                itemBeingDownloaded.operationStatus = respData.data.status.replace(/_/g, " ");
                itemBeingDownloaded.downloadProgress = respData.data.downloadProgress;  //percent Indicator
                thisNg.upgradeTasksLnk=true;
                break;
            case 'EXTRACTED_BUNDLE':
                itemBeingDownloaded.operationStatus = respData.data.status.replace(/_/g, " ");
                itemBeingDownloaded.downloadProgress = respData.data.downloadProgress;  //percent Indicator
                thisNg.upgradeTasksLnk=true;
                break;
            case 'REQUESTED_UPGRADE':
                itemBeingDownloaded.operationStatus = respData.data.status.replace(/_/g, " ");
                itemBeingDownloaded.downloadProgress = respData.data.downloadProgress;  //percent Indicator
                break;
            case 'RUNNING':
                itemBeingDownloaded.operationStatus = respData.data.status.replace(/_/g, " ");
                itemBeingDownloaded.pollDownloadHandler.unsubscribe();  //TBD
                itemBeingDownloaded.pollDownloadHandler = null;
                thisNg.upgradeTasksLnk=true;
                if (thisNg.isUpgradingAlertShown === false) {
                    thisNg.isUpgradingAlertShown = true;
                    thisNg.alert.info('System is being upgraded and may be unreachable until the upgrade is complete, please try logging in after some time.');
                }
                if (thisNg.isVsphereClient) {
                    thisNg.upgradeConfirmDlg = true;
                } else {
                    //thisNg.authSvc.logout();  //TBD 3.5.1 auto logout by adding in auth module 
                    thisNg.upgradeConfirmDlg = true;
                }
                break;
            case 'COMPLETE':
                if (respData.data.downloadProgress > 0) {
                    itemBeingDownloaded.isPerformingOperation = true;
                } else {
                    itemBeingDownloaded.isPerformingOperation = false;
                }
                itemBeingDownloaded.operationStatus = respData.data.status.replace(/_/g, " ");
                itemBeingDownloaded.pollDownloadHandler.unsubscribe();
                thisNg.upgradeTasksLnk=false;
                thisNg.afterDownload(1, itemBeingDownloaded, thisNg.getErrorFromJobData(respData.data));
                break;
            case 'FAILED':
                itemBeingDownloaded.isPerformingOperation = false;
                itemBeingDownloaded.operationStatus = respData.data.status.replace(/_/g, " ");
                itemBeingDownloaded.pollDownloadHandler.unsubscribe();
                thisNg.upgradeTasksLnk=false;
                //this.changeDownloadStatus(item);
                thisNg.afterDownload(0, itemBeingDownloaded, thisNg.getErrorFromJobData(respData.data));
                break;
        }
        // console.log("item in last upgrade", itemBeingDownloaded);
    }

    private getLastUpgradeJob(endpointObject): void {
        //console.log('last upgrade ....');
        let thisNg = this;
        let itemBeingDownloaded = null;
        if (endpointObject.resumeJobsData) {
            itemBeingDownloaded = thisNg.nspData.find(function (item) {
                //console.log('item ..... ',item);
                return item.systemId === endpointObject.resumeJobsData.endpointId;
            })

            if (itemBeingDownloaded) {

                if (endpointObject.downloadProgress || endpointObject.resumeJobsData.status == 'DOWNLOADING_BUNDLE') {
                    let payload = {
                        endpointId: endpointObject.resumeJobsData.endpointId,
                        version: endpointObject.resumeJobsData.version
                    }
                    // console.log('item download in progress ....',endpointObject);
                    itemBeingDownloaded.isPerformingOperation = true;
                    itemBeingDownloaded.pollDownloadHandler = thisNg.nspUpgradeService.pollJobStatus(payload, endpointObject._source.uuid).subscribe(data => {
                        thisNg.handlePollerResponse(data, itemBeingDownloaded);
                    }, error => {
                        let msg = thisNg.findErrorMessage(error);
                        itemBeingDownloaded.isPerformingOperation = false;
                        thisNg.afterDownload(0, itemBeingDownloaded, msg);

                    })
                } else {
                    //enable download button
                    itemBeingDownloaded.isPerformingOperation = false;
                    itemBeingDownloaded.isDownloading = false;
                    itemBeingDownloaded.isUpgrading = true;
                }
            }
        }
    }

    private getDownloadBundleStatusTesting(): void {
        let b = [];
        this.nspData.forEach(function (item, index) {
            item.downloadBundle = [];
            item.progressMsg = 'Running';
            item.updateProgressMsg = true;
            let found = _.findIndex(b, { cloudId: item.cloudId });
            if (found > -1) {
                if (item.availableVersions[0] === b[found].version) {
                    item.downloadBundle[0] = { version: item.availableVersions[0], show: true, _source: item._source };
                } else {
                    item.downloadBundle[0] = { version: item.availableVersions[0], show: false, _source: item._source };
                }
            } else {
                //item.downloadBundle[0] = {version: item.availableVersions[0], show: false};
            }
        })
    }

    private setDownloadBundleStatus(): void {
        let thisNg = this;
        let allBundles = this.availBundles;

        this.nspData.forEach(function (item, index) {
            item.downloadBundle = [];
            item.progressMsg = 'Running';
            item.updateProgressMsg = true;
            let found = _.findIndex(allBundles, { cloudId: item.cloudId });

            if (found > -1) {
                if (item.availableVersions[0] === allBundles[found].version) {
                    item.downloadBundle[0] = { version: item.availableVersions[0], show: true, _source: item._source };
                } else {
                    item.downloadBundle[0] = { version: item.availableVersions[0], show: false, _source: item._source };
                }
            } else {
                item.downloadBundle[0] = { version: item.availableVersions[0], show: false, _source: item._source };
            }
        })
    }

    private normalizeNspData(nspArr){
        let processedNspArray = nspArr.map(item=>{
            if(item['version']){
                item['originalVersion'] = item['version'] || '';
                item['version']= limitdecimals(item['version'] , '.' ,4);
            }      
            return item;
        });
        return processedNspArray;
    }

    private last_request_key_getAllNspData = 0;
    private getAllNspData(): void {
        const me = this;
        me.getHandler = me.nspUpgradeService.nspData.subscribe(
            nspJsonData => {
                nspJsonData = this.normalizeNspData(nspJsonData);
                me.nspData = [].concat(nspJsonData);
                if (me.nspData.length > 0) {
                    me.selected = me.nspData[0];    // set first item selected
                }
                me.getResumeJobsData(false);    //this is for local NSP endpoint
                // this.getHandler.unsubscribe();
                me.isLoading = false;
                if (me.nspData.length == 0) {
                    me.nspData = null;
                }
            });

        let last_request_key = me.last_request_key_getAllNspData = new Date().getTime();
        me.nspUpgradeService.loadAllNspUpgradeData().then(x => {
            if (last_request_key != me.last_request_key_getAllNspData) return; // ignore response
            // to things....
        });
    }

    private getRemoteNspData(): void {
        const me = this;
        me.getRemoteHandler = this.nspUpgradeService.remoteNspData.subscribe(
            remoteNspJsonData => {
                remoteNspJsonData = this.normalizeNspData(remoteNspJsonData);
                me.remoteNspUpgradeData = [].concat(remoteNspJsonData);
                me.remoteNspUpgradeData = _.uniqBy(me.remoteNspUpgradeData, 'systemId');
                if (me.remoteNspUpgradeData.length > 0) {
                    me.selected = me.remoteNspUpgradeData[0];    // set first item selected
                }
                me.getResumeJobsData(true); // this is for remote NSP endpoint
                me.isLoading = false;
            });
        me.nspUpgradeService.loadAllRemoteNspUpgradeData();
    }

    private refreshGrid(): void {
        this.isLoading = true;
        this.getAllNspData();
        this.getRemoteNspData();
    }

    ngOnDestroy() {
        if (this.downloadOvaBundleHandler) {
            this.downloadOvaBundleHandler.unsubscribe();
            this.downloadOvaBundleHandler = null;
        }
        if (this.getHandler) {
            this.getHandler.unsubscribe();
            this.getHandler = null;
        }
        if (this.getRemoteHandler) {
            this.getRemoteHandler.unsubscribe();
            this.getRemoteHandler = null;
        }
        if (this.downloadBundleHandler) {
            this.downloadBundleHandler.unsubscribe();
            this.downloadAndUpgrade = null;
        }
        if (this.startNspUpgradeHandler) {
            this.startNspUpgradeHandler.unsubscribe();
            this.startNspUpgradeHandler = null;
        }

        if (this.nspData) {
            this.nspData.forEach(function (item, index) {
                if (item.pollDownloadHandler != null) {
                    item.pollDownloadHandler.unsubscribe();
                    item.pollDownloadHandler = null;
                }
                if (item.statusHandler != null) {
                    item.statusHandler.unsubscribe();
                    item.statusHandler = null;
                }
            });
        }

        if (this.remoteNspUpgradeData) {
            this.remoteNspUpgradeData.forEach(function (item, index) {
                if (item.pollDownloadHandler != null) {
                    item.pollDownloadHandler.unsubscribe();
                    item.pollDownloadHandler = null;
                }
                if (item.statusHandler != null) {
                    item.statusHandler.unsubscribe();
                    item.statusHandler = null;
                }
            })
        }

    }

    private checkPairing(nspItem): boolean {
        if (nspItem.pairings.length > 1)
            return true;
        else if (nspItem.pairings.length === 1) {
            if (nspItem.pairings[0].componentType && nspItem.pairings[0].version)
                return true;
            else
                return false;
        } else
            return false;
    }

    private clickSelectBuild(event, nspItem): void {
        nspItem.showDropDown = !nspItem.showDropDown;
        let tmp = _.filter(this.nspData, { showDropDown: true });
        tmp.forEach(function (item) {
            if (!_.isEqual(item, nspItem))
                item.showDropDown = false;
        });
        event.preventDefault();
    }

    /* REFACTOR: rename "startDownloadOperation" or so... 
                 it would be better to split in 2 methods: to handle "menu/dropdown" binding & visibility,
                 and to perform an operation!
    */
    private startDownloadOperation(): void {
        let me = this;
        var currVer, nspItem, idx;
        if (me.selectedBuild != null) {
            currVer = me.selectedBuild['selectedVersion'];
            nspItem = me.selectedBuild['selectedAppliance'];
            idx = me.selectedBuild['latestAvailableVersionIndex'];

            me.selectedBuild['selectedVersion'] = null;
            me.selectedBuild['selectedAppliance'] = null;
            me.selectedBuild['latestAvailableVersionIndex'] = null;
        } else {
            // ??? currVer, nspItem, idx will be null
            return;
        }
        nspItem.selectedVersion = currVer.originalVersion;
        me.currentRowUpgrade = idx;
        me.nspBuild = currVer.originalVersion;
        me.isDownloadStarted = true;
        me.resetRowUpgradeData();
        me.downloadBundle(me.nspData[me.currentRowUpgrade]);
        me.isVersionOperationsDropdownVisible = false;
        me.isBuildDropdownVisible = false;
    }

    private clickCancelUpgrade(): void {
        this.scheduleUpgrade = false;
        this.upgradeConfirmDlg = false;
    }

    private resetRowUpgradeData(): void {
        this.nspData[this.currentRowUpgrade].showRunningBtn = true;
        this.nspData[this.currentRowUpgrade].showSuccessBtn = false;
        this.nspData[this.currentRowUpgrade].showErrorBtn = false;
        this.nspData[this.currentRowUpgrade].disableSelectBuildBtn = true;
        this.nspData[this.currentRowUpgrade].msg = "";
        this.nspData[this.currentRowUpgrade].progressMsg = "";
        this.nspData[this.currentRowUpgrade].cloudId = this.nspData[this.currentRowUpgrade].systemId;
        this.nspData[this.currentRowUpgrade].selectedVersion = this.nspBuild;
        this.nspData[this.currentRowUpgrade].downloadProgress = "";
        this.nspData[this.currentRowUpgrade].operationStatus = "";
        this.nspData[this.currentRowUpgrade].isDownloadStarted = this.isDownloadStarted;
        this.nspData[this.currentRowUpgrade].isPerformingOperation = true;
        this.nspData[this.currentRowUpgrade].isDownloading = true;
        this.nspData[this.currentRowUpgrade].isUpgrading = true;
        this.nspData[this.currentRowUpgrade].scheduledDate = this.scheduledDate;
        this.disableOkBtn = true;
        this.nspData[this.currentRowUpgrade].runningUpgradeData = {
            row: this.currentRowUpgrade,
            version: this.nspData[this.currentRowUpgrade].selectedVersion,
            endpointId: this.nspData[this.currentRowUpgrade].cloudId,
            siteinfo: {
                endpointId: this.nspData[this.currentRowUpgrade].systemId,
                version: this.nspData[this.currentRowUpgrade].selectedVersion
            },
            userInfo: {
                userName: this.userName,
                password: this.userPw
            }
        }
    }

    private clickOkUpgrade(): void {
        this.upgradeConfirmDlg = false;
        this.scheduleUpgrade = false;
        this.resetRowUpgradeData();
        this.upgradeNSP(this.nspData[this.currentRowUpgrade]);
    }

    private getSize(): number {
        return _.size(this.nspData);
    }

    private getRemoteApplianceSize(): number {
        return _.size(this.remoteNspUpgradeData);
    }

    private onUserNameEnter(): void {
        if (this.userName.length && this.userPw.length)
            this.clickOkUpgrade();
    }

    private onUserPwEnter(): void {
        if (this.userName.length && this.userPw.length)
            this.clickOkUpgrade();
    }

    private onUserNameKeyUp(event): void {
        this.userName = event.target.value;
        this.enableOrDisableOkBtn();
    }

    private onUserPasswordKeyUp(event): void {
        this.userPw = event.target.value;
        this.enableOrDisableOkBtn();
    }

    private enableOrDisableOkBtn(): void {
        (this.userName.length > 0 && this.userPw.length > 0) ? this.disableOkBtn = false : this.disableOkBtn = true;
    }

    private showErrorMessage(idx): void {
        this.isShowMsg = true;
    }

    private changeDownloadStatus(nsp): void {
        let i = _.find(nsp.downloadBundle, { version: nsp.runningUpgradeData.version, show: false });
        i.show = true;
    }

    private changeUploadStatus(nsp): void {
        let i = _.find(nsp.downloadBundle, { version: nsp.runningUpgradeData.version, show: true });
        i.show = false;
    }

    private pollRunningJob(item, jobId): void {
        let thisNg = this;
        item.pollDownloadHandler = this.nspUpgradeService.pollJobStatus(item, item._source.uuid).subscribe((data: any) => {
            if (data.isDone) {
                item.pollDownloadHandler.unsubscribe();
                if (!data.didFail)
                    return data.didFail;
                else
                    thisNg.afterUpgrade(0, item, this.getErrorFromJobData(data));
            } else {
                // show progress message
                if (data.jobData && data.jobData.response && data.jobData.response.result && data.jobData.response.result.stepsStatus) {
                    item.progressMsg = data.jobData.response.result.stepsStatus[0].status;
                } else
                    item.progressMsg = data.state;
                item.updateProgressMsg = true;

            }
        }, error => {
            let msg = this.findErrorMessage(error);
            thisNg.afterUpgrade(0, item, msg);
        })
    }

    private downloadBundle(item): void {
        let thisNg = this;
        thisNg.isDownloading = true;
        thisNg.isUpgrading = true;
        let payload = {};
        this.downloadBundleHandler = this.nspUpgradeService.downloadBundle(item.runningUpgradeData.siteinfo, item._source.uuid).subscribe(resp => {
            if (resp.success) {
                payload = {
                    endpointId: item.systemId,
                    version: item.selectedVersion
                };
                item.pollDownloadHandler = this.nspUpgradeService.pollJobStatus(payload, item._source.uuid).subscribe((data: any) => {
                    let respData = data;
                    /*
                    DOWNLOADING_BUNDLE
                    DOWNLOADED_BUNDLE
                    EXTRACTING_BUNDLE
                    EXTRACTED_BUNDLE
                    REQUESTED_UPGRADE
                    RUNNING
                    COMPLETE
                    FAILED
                    */
                    switch (respData.data.status) {
                        case 'DOWNLOADING_BUNDLE':
                            // console.log('STATUS ',respData.data.status);
                            item.downloadProgress = respData.data.downloadProgress; //percent Indicator
                            item.operationStatus = respData.data.status.replace(/_/g, " ");
                            item.isDownloading = true;
                            item.isUpgrading = true;
                            thisNg.upgradeTasksLnk=true;
                            break;
                        case 'DOWNLOADING_ADDON':
                            item.downloadProgress = respData.data.downloadProgress; //percent Indicator
                            item.operationStatus = respData.data.status.replace(/_/g, " ");
                            item.isDownloading = true;
                            item.isUpgrading = true;
                            thisNg.upgradeTasksLnk=true;
                            break;
                        case 'DOWNLOADED_BUNDLE':
                            //console.log('STATUS ', respData.data.status);
                            item.operationStatus = respData.data.status.replace(/_/g, " ");
                            item.downloadProgress = respData.data.downloadProgress;
                            item.isUpgrading = false;
                            thisNg.upgradeTasksLnk=false;
                            item.pollDownloadHandler.unsubscribe();
                            break;

                        case 'COMPLETE':
                            //console.log('STATUS ',respData.data.status);
                            item.isPerformingOperation = false;
                            item.operationStatus = respData.data.status.replace(/_/g, " ");
                            item.pollDownloadHandler.unsubscribe();
                            thisNg.upgradeTasksLnk=false;
                            this.afterDownload(1, item, this.getErrorFromJobData(respData.data));
                            break;

                        case 'FAILED':
                            //console.log('STATUS ',respData.data.status);
                            item.isPerformingOperation = false;
                            item.operationStatus = respData.data.status.replace(/_/g, " ");
                            item.pollDownloadHandler.unsubscribe();
                            thisNg.upgradeTasksLnk=false;
                            //this.changeDownloadStatus(item);
                            this.afterDownload(0, item, this.getErrorFromJobData(respData.data));
                            break;

                    }
                }, error => {
                    let msg = this.findErrorMessage(error);
                    this.afterDownload(0, item, msg);

                })
            } else {
                this.afterDownload(0, item, resp.errors[0].text);
            }
        }, error => {
            let msg = this.findErrorMessage(error);

            this.afterDownload(0, item, msg);
        })
    }

    private upgradeNSP(item): void {
        let me = this,
            payload = {};
        this.startNspUpgradeHandler = this.nspUpgradeService.doUpgradeNSP(item, item._source.uuid).subscribe(resp => {
            if (resp.success) {
                //item.jobId = resp.data.jobId;
                payload = {
                    'endpointId': item.systemId,
                    'version': item.selectedVersion
                };
                item.pollDownloadHandler = this.nspUpgradeService.pollJobStatus(payload, item._source.uuid).subscribe(data => {
                    me.handlePollerResponse(data, item);
                }, error => {
                    let msg = this.findErrorMessage(error);
                    item.isPerformingOperation = false;
                    this.afterUpgrade(0, item, msg);
                });
            } else {

                this.afterUpgrade(0, item, resp.errors[0].text);
            }
        }, error => {
            let msg = this.findErrorMessage(error);
            this.afterUpgrade(0, item, msg);
        });

    }

    private scheduleUpgradeNSP(item): void {
        let me = this,
            payload = {};

        this.startNspUpgradeHandler = this.nspUpgradeService.doScheduledUpgradeNSP(item, item._source.uuid).subscribe(resp => {
            if (resp.success) {
                //item.jobId = resp.data.jobId;
                if (item.runningUpgradeData.scheduledDate != '') {
                    payload = {
                        endpointId: item.systemId,
                        version: item.selectedVersion,
                        scheduleAt: item.scheduledDate
                    };
                }
                /*payload = {
                    'endpointId': item.systemId,
                    'version': item.selectedVersion
                };*/
                item.pollDownloadHandler = this.nspUpgradeService.pollJobStatus(payload, item._source.uuid).subscribe(data => {
                    me.handlePollerResponse(data, item);
                }, error => {
                    let msg = this.findErrorMessage(error);
                    item.isPerformingOperation = false;
                    this.afterUpgrade(0, item, msg);
                });
            } else {

                this.afterUpgrade(0, item, resp.errors[0].text);
            }
        }, error => {
            let msg = this.findErrorMessage(error);
            this.afterUpgrade(0, item, msg);
        });

    }


    private findErrorMessage(error): string {
        let msg = 'Server Error';
        let err = error;
        if (err.errors && err.errors[0].text) {
            msg = err.errors[0].text;
        } else if (err._body) {
            msg = err._body;
        } else if (err.message) {
            msg = err.message;
        }
        return msg;
    }

    private afterDownload(result, nsp, msg): void {
        nsp.disableSelectBuildBtn = false;
        nsp.jobId = "";
        if (result === 1) {
            nsp.showErrorBtn = false;
            nsp.showSuccessBtn = true;
            nsp.isUpgrading = false;
        } else {
            nsp.showErrorBtn = true;
            nsp.showSuccessBtn = false;
            nsp.isPerformingOperation = false;
            nsp.isUpgrading = false;
            nsp.isDownloading = false;
        }
        nsp.showRunningBtn = false;
        nsp.theMessage = msg;
    }

    private afterUpgrade(result, nsp, msg): void {
        nsp.disableSelectBuildBtn = false;
        nsp.jobId = '';
        if (result === 1) {
            nsp.showErrorBtn = false;
            nsp.showSuccessBtn = true;
            nsp.version = nsp.runningUpgradeData.version;
        } else {
            nsp.showErrorBtn = true;
            nsp.showSuccessBtn = false;
        }
        nsp.showRunningBtn = false;
        nsp.theMessage = msg;
    }

    private getErrorFromJobData(data): string {

        return data.message;
    }


    downloadAndUpgrade(): void {
        let me = this;
        var currVer, nspItem, idx;
        if (me.selectedBuild != null) {
            currVer = me.selectedBuild['selectedVersion'];
            nspItem = me.selectedBuild['selectedAppliance'];
            idx = me.selectedBuild['latestAvailableVersionIndex'];

            me.selectedBuild['selectedVersion'] = null;
            me.selectedBuild['selectedAppliance'] = null;
            me.selectedBuild['latestAvailableVersionIndex'] = null;
        }    
        me.nspBuild = currVer.originalVersion;
        me.currentRowUpgrade = idx;
        me.resetRowUpgradeData();
        me.upgradeNSP(me.nspData[me.currentRowUpgrade]);
        me.isVersionOperationsDropdownVisible = false; //!me.isVersionOperationsDropdownVisible;
    }

    displaySchedule(currVer, nspItem, idx): void {
        let rowData = {}
        let me = this;
        var currVer, nspItem, idx;
        if (me.selectedBuild != null) {
            currVer = me.selectedBuild['selectedVersion'];
            nspItem = me.selectedBuild['selectedAppliance'];
            idx = me.selectedBuild['latestAvailableVersionIndex'];

            me.selectedBuild['selectedVersion'] = null;
            me.selectedBuild['selectedAppliance'] = null;
            me.selectedBuild['latestAvailableVersionIndex'] = null;
        }

        rowData['currVer'] = currVer.version;
        rowData['nspItem'] = nspItem;
        rowData['idx'] = idx;
        me.scheduleUpgrade = true;
        //this.upgradeConfirmDlg = true;
        me.scheduleData = rowData;
        me.isVersionOperationsDropdownVisible = false; //!me.isVersionOperationsDropdownVisible;
    }

    scheduledUpgrade(): any {
        if (!this.scheduledDate) {
            return false;
        }

        this.scheduleUpgrade = false;
        this.upgradeConfirmDlg = false;
        this.currentRowUpgrade = this.scheduleData['idx'];
        this.nspBuild = this.scheduleData['currVer'];
        this.resetRowUpgradeData();
        //this.upgradeNSP(this.nspData[this.currentRowUpgrade]);
        this.scheduleUpgradeNSP(this.nspData[this.currentRowUpgrade]);
    }

    setUpScheduledUpgrade(): void {
        this.downloadAndUpgrade();

    }

    showBuildMenu(): void {
        this.buildList = !this.buildList;
    }

    onNotify($event) {
        //console.log('$event == ',$event);
        this.scheduledDate = $event;
        var schDate = new Date(this.scheduledDate * 1000);
        if (schDate.getHours() > 12) {
            this.upgradeScheduleTime = schDate.toISOString().split('T')[0] + " at " + (schDate.getHours() - 12) + ":" + schDate.getMinutes() + 'PM';
        }
        else {
            this.upgradeScheduleTime = schDate.toISOString().split('T')[0] + " at " + schDate.getHours() + ":" + schDate.getMinutes() + 'AM';
            //this.upgradeScheduleTime ==schDate.getFullYear()+":"+(schDate.getMonth()+1)+":"+schDate.getDay()+":"+schDate.getHours() +":"+schDate.getMinutes()+" AM";
        }

        //console.log('scheduledDate ::',this.scheduledDate,' scheduleData: ',this.scheduleData['idx'] );
    }

    //polling for OVA bundle till its completed and handle errors
    handleDownloadOvaResponse(data: any) {
        let me = this;
        if (data == null) {
            me.ovaBundleDownloadLink = '';
            //me.downloadOvaBundleHandler.unsubscribe();
            return;
        }

        let response = data;
        if (response.status == '204') {
            me.ovaBundleDownloadLink = '';
            me.downloadOvaBundleHandler.unsubscribe();
            me.isOvaBundleSubscribed = false;
            return;
        }

        if (response.data) {
            switch (response.data.status) {
                case 'COMPLETE':
                    if ((response.data.downloadOvaLinkInformation.downloadUrl == 'undefined') ||
                        (response.data.downloadOvaLinkInformation.hasOwnProperty('downloadUrl') == false)
                    ) {
                        me.ovaBundleDownloadLink = '';
                        me.ovaLinkInfo = response.data.downloadOvaLinkInformation;
                        me.isOvaBundleSubscribed = false;
                        me.showLinkSpinner = false;
                        me.enableInfoLink = true;
                        me.downloadOvaBundleHandler.unsubscribe();
                    }
                    else if (response.data.downloadOvaLinkInformation.downloadUrl != '') {
                        me.ovaBundleDownloadLink = response.data.downloadOvaLinkInformation.downloadUrl;
                        me.isOvaBundleSubscribed = false;
                        me.downloadOvaBundleHandler.unsubscribe();
                    }
                    break;
            }

        }
    }

    // Get the downloadID and pass it to OVA poller
    downloadOvaBundle() {
        let me = this;
        let downloadJobId;
        me.isOvaBundleSubscribed = true;
        if (!me.showHcxEDownloadLink && !this.isHCXWithoutCnC) {
            me.nspUpgradeService.downloadOvaBundleFile().subscribe(
                response => {
                    if (response.success) {
                        downloadJobId = response.data.downloadId;
                    }
                    me.downloadOvaBundleHandler = me.nspUpgradeService.pollOvaBundleDownloadStatus(downloadJobId).subscribe(data => {
                        me.handleDownloadOvaResponse(data);
                    }, error => {
                        //console.log('error', error);
                        this.isLinkAvailable=false;
                    });
                    //console.log('response', response)
                },
                error => {
                   // console.log('response error', error)
                },
                () => { }
            )
        }
    }

    // Display Ova links
    checkOvaBundle() {
        let me = this;
        me.ovaLinkInfo = "";
        //me.downloadOvaBundle()
        me.ovaBundleLink = true;    //Check to enable "Request Down Link" button 
        me.isLinkAvailable = true;  //Check to enable "Request Down Link" button with spinner

        let timerId;
        if (me.ovaBundleDownloadLink.length == 0) {
            //timer to show spinner after user clicks on "Request Down load link"
            if (!me.isOvaBundleSubscribed) {
                me.downloadOvaBundle();
                me.showLinkSpinner = true;
                me.enableInfoLink = false;
                timerId = setTimeout(function () {
                    me.showLinkSpinner = false;
                    me.enableInfoLink = true;  //shows info icon when there is no link available
                }, 180000);
            }
        }
        else {
            clearTimeout(timerId);
        }

    }

    //Copy url to clipboard
    copyOvaBundleLink(event) {
        let me = this;
        let urlToCopy = me.ovaBundleDownloadLink;
        clipboardJs.copy(urlToCopy);
    }

    clickOnVersionNodata() {
        // console.log('static Data');
    }

    downloadAndUpgradeNoData() {
        //console.log('static Data');
    }

    displayScheduleNoData() {
        // console.log('static Data');
    }

    ngOnChanges() {
        //this.getUpdatedNspData();
    }

    ngAfterViewChecked() {
        // prevents exception error when remote grid data 
        this.cdRef.detectChanges();
        //this.getUpdatedNspData();
    }

    ngAfterContentChecked() {
        //this.getUpdatedNspData();
    }

    ngAfterViewInit() {
        //this.getUpdatedNspData();
    }

    trackByIndex(index: number, obj: any): any {
        return index;
    }

    //////3.5.1

    saveSelectedRowIndex(index){
        if(this.indexVal!==index){
            this.indexVal =index;
        }
    }

    showBuildDropDown(e, dataItem, index) {
        let me = this;
        let currentTag = 'buildDropDownMenu';
        //pass data Item to selectedBuild object
        me.selectedBuild['selectedAppliance'] = dataItem;
        me.selectedBuild['latestAvailableVersionIndex'] = index;
        me.buildDropDownPos = '' + ((e.currentTarget.getBoundingClientRect().y - $("nspupgrade")[0].getBoundingClientRect().top) + 2) + 'px';
        me.buildDropDownList = dataItem;
        me.buildDropDown['dataItem'] = dataItem;
        me.buildDropDown['index'] = index;
        me.isBuildDropdownVisible = true;
        // view model to determine where to insert 'Old Builds' Label in dropdown
        me.buildDropDown['startindexForOldBuildLabel'] = dataItem.availableBundles.findIndex((item) => item.showNewBuildTag === false);
        me.isVersionOperationsDropdownVisible = false;
        e.stopPropagation();
    }

    cancelSchedule(e, dataItem, index) {
        let me = this;
    }

    editSchedule(e, dataItem, index) {
        let me = this;
        me.downloadAndUpgrade();
    }


    private checkEvent() {
        let me = this;
        document.addEventListener('click', function (e) {
            // TODO: this should be triggered only is some dropdowns are visible!
            //       otherway it is "inaccurate"

            // state normalization
            me.isVersionOperationsDropdownVisible = false;
            me.isBuildDropdownVisible = false;
        }, false);

    }

    showOperationDropdown(e, buildVersion, appliance, index) {
        let me = this;
        if ((e.currentTarget.id) && (appliance.availableBundlesObjects.length == 1)) {
            me.buildDropdownPos = "23.2em";
        } else {
            me.buildDropdownPos = "27.2em";
        }

        let _pageY;
        let currentPos, newPos;
        me.selectedBuild = buildVersion;
        me.operatingRowStatus = index
        currentPos = e.clientY;
        let currentTag = e.target.id;
        me.selectedBuild['selectedVersion'] = buildVersion;
        me.selectedBuild['selectedAppliance'] = appliance;
        me.selectedBuild['latestAvailableVersionIndex'] = index;
        let bundleList = appliance.availableBundlesObjects;
        let bundleIndex;
        for (let i = 0; i < bundleList.length; i++) {
            if (buildVersion.originalVersion == bundleList[i].originalVersion) {
                bundleIndex = i;
                break;
            }
        }
        for (let x = 0; x < bundleList.length; x++) {
            if (appliance.selectedVersion == bundleList[x].bundle) {
                bundleList[x].isUpgradeing = appliance.isUpgrading;
            }
        }
        if (appliance.availableBundlesObjects[bundleIndex].externalReleaseNote == "") {
            appliance.availableBundlesObjects[bundleIndex].externalReleaseNote = '{"features":"","issues":"","security":""}';
        } else {
            try {
                me.releaseNote = JSON.parse(appliance.availableBundlesObjects[bundleIndex].externalReleaseNote);
                this.releaseNoteErr = false
            } catch(err) {
                this.releaseNoteErr = true
                me.releaseNote = JSON.parse(JSON.stringify({features: DEFAULT_RELEASE_NOTE_TXT, issues: DEFAULT_RELEASE_NOTE_TXT, security: DEFAULT_RELEASE_NOTE_TXT}))
            }    
        }

        if (me.yPos == undefined) {
            me.yPos = e.clientY;
        }


        me.isBuildDropdownVisible = false;
        if (e.currentTarget.classList.contains("version-link-button")) {
            me.isVersionOperationsDropdownVisible = true;

            if (e.currentTarget.classList.contains('dropdown-item')) {
                me.isBuildDropdownVisible = true;
                me.yPos = e.clientY + 40;
                _pageY = (Math.floor((e.clientY + me.yPos) / 50)) + 'em';
            } else {
                _pageY = (Math.floor((e.clientY / 70) + 3)) + 'em';
            }
            // XXX "left-positioning" of operations dropdown is specified in html (by duplicating menu!)
            //     and is driven by "showBundleDropDown" flag! (which is not very good...)
            // REFATCOR: have single menu with conditional css or style...

        }
        _pageY = ((e.clientY) / 2) + 'px';
        let topActionMenuPos;
        me.showHcxEDownloadLink ? topActionMenuPos = 260 : topActionMenuPos = 150;
        me.cssTopSubmenu = '' + ((e.currentTarget.getBoundingClientRect().y - $("nspupgrade")[0].getBoundingClientRect().top) - topActionMenuPos) + 'px';
        me.yPos = e.clientY;
        e.stopPropagation();
    }

    private validHtmlFeature: boolean;
    private validHtmlIssues: boolean;
    private validHtmlSecurity: boolean;
    showDefaultLocalReleaseNoteAvailable(e) {
        let me = this;
        me.defaultLocalReleaseNoteDialogue = true;
        let regex = /(&nbsp;|<([^>]+)>)/ig
        let htmlTest = /<(br|basefont|hr|input|source|frame|param|area|meta|!--|col|link|option|base|img|wbr|!DOCTYPE).*?>|<(a|abbr|acronym|address|applet|article|aside|audio|b|bdi|bdo|big|blockquote|body|button|canvas|caption|center|cite|code|colgroup|command|datalist|dd|del|details|dfn|dialog|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frameset|head|header|hgroup|h1|h2|h3|h4|h5|h6|html|i|iframe|ins|kbd|keygen|label|legend|li|map|mark|menu|meter|nav|noframes|noscript|object|ol|optgroup|output|p|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video).*?<\/\2>/i

        if (me.defaultLocalReleaseNoteDialogue) {
            me.innerContentFeatures = me.defaultLocalReleaseNotes.features//me.releaseNote.features;
            this.validHtmlFeature = htmlTest.test(me.innerContentFeatures);
            me.innerContentIssues = me.defaultLocalReleaseNotes.issues//me.releaseNote.issues;
            this.validHtmlIssues = htmlTest.test(me.innerContentIssues);
            me.innerContentSecurity = me.defaultLocalReleaseNotes.security//me.releaseNote.security;
            this.validHtmlSecurity = htmlTest.test(me.innerContentSecurity);

            me.defaultLocalReleaseNoteFeatures = me.defaultLocalReleaseNotes.features.split("\n");
            me.defaultLocalReleaseNoteIssues = me.defaultLocalReleaseNotes.issues.split("\n");
            me.defaultLocalReleaseNoteSecurity = me.defaultLocalReleaseNotes.security.split("\n");
            return;
        }

        me.isVersionOperationsDropdownVisible = false;
        me.isBuildDropdownVisible = false;
        e.stopPropagation();
    }

    showReadmeDialogue(e) {
        let me = this;
        let index = me.operatingRowStatus;
        let regex = /(&nbsp;|<([^>]+)>)/ig
        let htmlTest = /<(br|basefont|hr|input|source|frame|param|area|meta|!--|col|link|option|base|img|wbr|!DOCTYPE).*?>|<(a|abbr|acronym|address|applet|article|aside|audio|b|bdi|bdo|big|blockquote|body|button|canvas|caption|center|cite|code|colgroup|command|datalist|dd|del|details|dfn|dialog|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frameset|head|header|hgroup|h1|h2|h3|h4|h5|h6|html|i|iframe|ins|kbd|keygen|label|legend|li|map|mark|menu|meter|nav|noframes|noscript|object|ol|optgroup|output|p|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video).*?<\/\2>/i

        if (me.releaseNote) {
            //console.log(this.releaseNote);
            me.innerContentFeatures = me.releaseNote.features;
            this.validHtmlFeature = htmlTest.test(me.innerContentFeatures);
            me.innerContentIssues = me.releaseNote.issues;
            this.validHtmlIssues = htmlTest.test(me.innerContentIssues);
            me.innerContentSecurity = me.releaseNote.security;
            this.validHtmlSecurity = htmlTest.test(me.innerContentSecurity);
            me.releaseNoteFeatures = (me.releaseNote && me.releaseNote.features && me.releaseNote.features.split("\n")) || [];
            me.releaseNoteIssues = (me.releaseNote && me.releaseNote.issues && me.releaseNote.issues.split("\n")) || [];
            me.releaseNoteSecurity = (me.releaseNote && me.releaseNote.security && me.releaseNote.security.split("\n")) || [];
        }

        if (((me.releaseNoteFeatures.length == 1) && (me.releaseNoteFeatures[0] == "")) &&
            ((me.releaseNoteIssues.length == 1) && (me.releaseNoteIssues[0] == "")) &&
            ((me.releaseNoteSecurity.length == 1) && (me.releaseNoteIssues[0] == ""))) {
            me.releaseNoteFeatures = [""];
            me.releaseNoteIssues = [""];
            me.releaseNoteSecurity = [""];
        }
        me.readMeDialogue = true;
        me.isVersionOperationsDropdownVisible = false;
        me.isBuildDropdownVisible = false;

        e.stopPropagation();
    }

    showUpgradeConfirmationDialogue(e, vinfo, dataItem, i) {
        let me = this;
        let upgradeItem = {};
        upgradeItem['vinfo'] = vinfo;
        upgradeItem['dataItem'] = dataItem;
        upgradeItem['idx'] = i;

        me.upgradeRow = upgradeItem;
        me.isUpgradeConfirmationDialogVisible = true;
        // state normalization... 
        me.isVersionOperationsDropdownVisible = false; //!me.isVersionOperationsDropdownVisible;
        me.isBuildDropdownVisible = false;
        e.stopPropagation();
    }

    cancelUpgrade(e) {
        let me = this;
        // state normalization...
        me.isUpgradeConfirmationDialogVisible = false;
        me.isVersionOperationsDropdownVisible = false; //!me.isVersionOperationsDropdownVisible;
        me.isBuildDropdownVisible = false;

        e.stopPropagation();
    }

    startUpgrade(e) {
        let me = this;
        me.downloadAndUpgrade(/*vinfo, dataItem, idx*/);

        // state normalization...
        me.isUpgradeConfirmationDialogVisible = false;
        me.isVersionOperationsDropdownVisible = false; //!me.isVersionOperationsDropdownVisible;
        me.isBuildDropdownVisible = false;

        e.stopPropagation();
    }

    copyToolTipNotes(notes) {
        clipboardJs.copy(notes);
    }

    private getEnabledFeatures(): any {
            this.featureEnablementService.getFeatureEnablement(
                this.nspUpgradeService.getLocalHcmReference()['hcsp']['uuid'],
                {
                    feature: 'ADMINISTRATION'
                }
            ).subscribe((result:any) => {
                if (result.errors && result.errors.length > 0) {
                    let errorMessage: string = '';
                    for (const error of result.errors) {
                        errorMessage = errorMessage.concat(errorMessage, error.text);
                        console.log(errorMessage);
                    }
                    console.error(JSON.stringify(errorMessage));
                } else {
                    this.featureMap.set('ADMINISTRATION', result);
                    this.showHcxEDownloadLink = this.isFeatureEnabled('ADMINISTRATION', 'ShowHcxEDownloadLink');
                    this.isEoGS = this.isFeatureEnabled('ADMINISTRATION', 'isEoGS');
                }
            }, (error) => {
                console.error("'Error calling feature enablement API:", error);
            }
            );
    }

    private isFeatureEnabled(feature: string, operation: string): boolean {
        if (!!this.featureMap) {
            const featureEnablement = this.featureMap.get(feature);
            if (!!featureEnablement) {
                if (!!featureEnablement['operations'] && !!featureEnablement['operations'].includes(operation)) {
                    return true;
                }
            }
        }
        return false;
    }

    downloadedBuilds() {
        let me = this;
      //  me.upgradeTasksLnk = true;
        let buildSelection = me.selectedBuild['originalVersion'];
        let downloadedBuilds = [];
        let downloadedBuild = me.checkCurrentDownloadVersion();

        if (downloadedBuild != undefined) {
            downloadedBuilds.push(downloadedBuild)
        }

        let alreadyDownloadedBuild = this.checkAvailableBuildsArrayForDownloadedBuilds(me.nspData[0].availableBundles);
        if (alreadyDownloadedBuild != undefined && downloadedBuilds.indexOf(alreadyDownloadedBuild) === -1) {
            downloadedBuilds.push(alreadyDownloadedBuild);
        }  
        
        me.selectedBuild['isUpgradeable'] =  downloadedBuilds.indexOf(buildSelection) !== -1 ? true:false;
    }

    private checkAvailableBuildsArrayForDownloadedBuilds(availableBundles: any): string {
        for (var i = 0; i < availableBundles.length; i++){
            if (availableBundles[i].status === "DOWNLOADED_BUNDLE"){
                return availableBundles[i].originalVersion;
            }
        }
    }

    private downloadedVersion;
    private isDownloadCompleted() {
        //"NOTIFICATION_PUSHED"
        let me = this;
        if (me.nspData[0].resumeJobsData != undefined) {
            me.downloadedVersion =me.nspData && Array.isArray(me.nspData) &&  me.nspData.length>0 && me.nspData[0].resumeJobsData && me.nspData[0].resumeJobsData.version && limitdecimals(me.nspData[0].resumeJobsData.version, '.', 4);
            if ((me.nspData[0].resumeJobsData.status == "DOWNLOADED_BUNDLE") || (me.nspData[0].operationStatus == "DOWNLOADED BUNDLE")) {
                return true;
            }
        }
    }

    private checkCurrentDownloadVersion(is5BitVersion?:boolean) {
        let me = this;
        let jobsData;
        if (me.nspData[0] != undefined) {
            jobsData = me.nspData[0];
            if ((jobsData.operationStatus == "DOWNLOADING BUNDLE") || (jobsData.operationStatus == "DOWNLOADED BUNDLE")) {
                if (jobsData.selectedVersion != undefined) {
                    if(is5BitVersion){
                        return limitdecimals(jobsData.selectedVersion, '.', 4 );
                    }else{
                        return jobsData.selectedVersion;
                    }
                } else if (jobsData.resumeJobsData) {
                    if(is5BitVersion){
                        return limitdecimals(jobsData.resumeJobsData.version, '.', 4 );
                    }else{
                        return jobsData.resumeJobsData.version;
                    }
                }
            }else {
                if (jobsData.resumeJobsData && jobsData.resumeJobsData.status == "DOWNLOADED_BUNDLE") {
                    return jobsData.resumeJobsData.version;
                }
            }
        }
    }

    public copyRowToClipboard(item) {
        if (!item) {
            return;
        }
        let str: string = '';
        str += item.version ? 'HCX Version: ' +item.version + "\n" : '';
        str += item.systemId ? 'HCX System Id: ' + item.systemId + "\n" : '';
        str += item.systemName ? 'HCX System Name: ' + item.systemName + "\n" : '';
        str += item.systemType ? 'HCX System Type: ' + item.systemType + "\n" : '';
        str += item.vcVersion ? 'vC Version: ' + item.vcVersion + "\n" : '';
        str += item.nsxVersion ? 'NSX Version: ' + item.nsxVersion + "\n" : '';
        clipboardJs.copy(str);
    }

    public setMenu() {
        let me = this;
        clearTimeout(me.isNspDataAvailable);
        if (me.nspData == undefined) {
            //console.log('refresh test');
            me.isMenuClicked = true;
            me.upgradeTasksLnk=true;
            me.isNspDataAvailable = setTimeout(function () {
                if (me.nspData) {
                    me.isMenuClicked = false;
                    me.upgradeTasksLnk=false;
                    this.upgradeProgress=false;
                }
            }, 10000);
        } else {
            //console.log('bundles length', me.nspData[0].availableBundles.length);
            if (me.nspData[0].hasOwnProperty('resumeJobsData') || (me.nspData[0].availableBundles.length > 0)) {
                me.isMenuClicked = true;
                this.upgradeProgress=false;
            }
            me.isNspDataAvailable = setTimeout(function () {
                me.isMenuClicked = false;
            }, 10000);
        }
    }

    routeContent() {
        this.router.navigate(['upgradeapp']);
        this.router.navigateByUrl('upgradeapp', { skipLocationChange: true }).then(() => {
            this.router.navigate(['administration/upgradeapp']);
        }); 
      // window.location.reload();
     }
    isUpgradeCheckDone(data) {
        const me =this;
        this.updateStatus = data.items[0].status;
        this.upgradeTaskData = data;
       this.upgradeMsg="Service Update: " + data.items[0].message;        
        if((data.items[0].status == 'COMPLETED') && (data.items[0].message.indexOf('No') == -1)) {
            this.nspUpgradeService.getCheckNotificationsPromise('null').then(resp=> {
                if(resp.data.items.length != 0) {
                const bundleData=resp.data.items;
                /* this.nspData[0].availableBundles.filter((el,idx)=>{
                     if(el.version != this.nspData[0].availableBundles[idx].version) {

                     }
                    });*/        
                // Get the versions already available for update
                let availableVer = ((this.nspData && Array.isArray(this.nspData) && this.nspData.length > 0 && this.nspData[0].availableBundles && Array.isArray(this.nspData[0].availableBundles)) && this.nspData[0].availableBundles.map(el=> el.version + "." + el.buildNumber)) || []; 

                 bundleData.forEach((el,idx)=> {
                     if(availableVer.indexOf(el.version) == -1){ // check if the version is already present, if so don't add the item
                        this.nspData[0].availableBundles.push(el)
                      }
                 });
                 bundleData.forEach((el,idx)=>{
                     me.nspData[0].availableBundlesObjects.push({bundle:el.version,date:'NA',externalReleaseNote:el.externalReleaseNote})
                 });

                this.nspUpgradeService.normalizeAvailableUpgradeBundlesDataList(this.nspData[0])

                }
            });
            this.isMenuClicked=false;    
           this.setMenu();
           this.upgradeCheckHandler.unsubscribe();  
        }
        if((data.items[0].status == 'COMPLETED') && (data.items[0].message.indexOf('No') > -1)) { 
            this.setMenu();
            this.upgradeCheckHandler.unsubscribe(); 
            me.upgradeTasksLnk=true;
           // this.upgradeProgress=false;
        }
        if (data.items[0].status == 'FAILED') {
            this.upgradeCheckHandler.unsubscribe(); 
            this.upgradeProgress=false;
            this.isMenuClicked=false;
            this.upgradeTasksLnk=false;
        }
      
    }

    //Check for upgradde and get/set jobId, pass jobbId to checkUpgradeStatus(jobbId)
    public upgradeProgress:boolean=false;
    checkForUpgrade() {
        this.upgradeMsg="Service Update: Checking for Update"
            this.upgradeProgress=true;
            this.upgradeStatusBanner=true;
            let hcspUUID = this.nspUpgradeService.getLocalHcmReference()['hcsp'] && this.nspUpgradeService.getLocalHcmReference()['hcsp']['uuid'];
            this.nspUpgradeService.checkForUpgrade(hcspUUID)
            .then((el:any)=> {
              this.upgradeTaskData = el.data;
              this.jobId = this.upgradeTaskData['jobId'];
              if (el.data.hasOwnProperty('jobId')) {
                  this.isMenuClicked=true;
                this.checkUpgradeStatus(this.upgradeTaskData['jobId'], hcspUUID)
                this.upgradeTasksLnk=true;
              } 
          
          }).catch(el=> {
              this.alert.warning(el)
          });;
    }

    downloadUpgradeLogs() {
        this.upgradeLogsNotFound = false;
        this.upgradeUpgradeLogProgress = true
        let hcspUUID = this.nspUpgradeService.getLocalHcmReference()['hcsp'] && this.nspUpgradeService.getLocalHcmReference()['hcsp']['uuid'];
        this.nspUpgradeService.downloadUpgradeLogs(hcspUUID)
            .subscribe((response: HttpResponse<Blob>) => {
                let filename: string = this.getFileName(response);
                let binaryData = [];
                binaryData.push(response.body);
                let downloadLink = document.createElement('a');
                downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: 'blob' }));
                downloadLink.setAttribute('download', filename);
                document.body.appendChild(downloadLink);
                downloadLink.click();
            },error => {
                this.upgradeLogsNotFound = true;
            },()=> {
                this.upgradeUpgradeLogProgress = false;   
             });
    }

    getFileName(response: HttpResponse<Blob>) {
        let filename: string;
        try {
          const contentDisposition: string = response.headers.get('content-disposition');
          filename = contentDisposition.split(';')[1].trim().split('=')[1].replace(/"/g, '');
        }
        catch (e) {
          filename = 'upgrade.log';
        }
        return filename;
      }
    
    checkUpgradeStatus(jobId, hcspUUID) {
        this.upgradeCheckHandler = this.nspUpgradeService.pollUpgradeTasks(jobId, hcspUUID).subscribe(el=> {
            this.upgradeTaskData = el.data;
            //this.upgradeMsg=el.data.items[0].status + ":" + el.data.items[0].message;
            this.upgradeMsg="Service Update: " + el.data.items[0].message;
            this.isUpgradeCheckDone(el.data); 
        },error => {
            this.upgradeProgress=false;
            this.alert.warning(error)
        },()=> {
           // console.log('complete!!');           
        });
    }

  

    checkApplianceUpgradeSchedule() {
        this.nspUpgradeService.checkApplianceUpgradeSchedule().subscribe((resp:any)=>{
            this.applianceScheduled = resp.items[0];
        },(error) => {
            this.alert.danger(error);
        },() => {
        });
    }    

}



// WEBPACK FOOTER //
// ./src/publisher/src/publisher-ui/upgrade/nsp-upgrade.component.ts